import { useEffect, useState } from "react";
import {
  Box,
  Button,
  InputAdornment,
  MenuItem,
  TextField,
  IconButton,
} from "@mui/material";
import { ReactComponent as ArrowbackIcon } from "../../Assets/arrowback.svg";
import Grid from "@mui/material/Grid2";
import {
  createsetCookie,
  EditsetCookie,
  getCookiesData,
} from "../../Services/ExperienceApi";
import { toast, ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";

function EditSetCookie() {
  const [isReadable, setIsReadable] = useState(true);
  const [cookieName, setCookieName] = useState("");
  const [cookieValue, setCookieValue] = useState("");
  const [path, setPath] = useState("");
  const [domain, setDomain] = useState("");
  const [noExpiration, setNoExpiration] = useState(false);
  const [expirationValue, setExpirationValue] = useState("");
  const [timeUnit, setTimeUnit] = useState("days");
  const [errors, setErrors] = useState({
    name: "",
    value: "",
    path: "",
    expirationValue: "",
  });
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("Set cookie");
  const sessionData = sessionStorage.getItem("pendingNodeAddition");
  const sessionObj = sessionData ? JSON.parse(sessionData) : {};
  const [titleError, setTitleError] = useState(false);
  const cookie = location.state?.data.id;
  const meterValueId =
    location.state?.data.meter_value_id || sessionObj.meterValueId;
  const experienceId =
    location.state?.data.experinceId || sessionObj.experinceId;
  const fullSegmentId = location.state?.data.segmentId || sessionObj.segmentId;
  const segmentId = location.state?.data.segmentId
    ? fullSegmentId.split("_")[1]
    : fullSegmentId;
  let cookieId: string | null = null;
  if (cookie) {
    const parts = cookie.split("_");
    cookieId = parts.length > 1 ? parts[1] : cookie;
  }
  const handleToggle = () => {
    setIsReadable((prev) => !prev);
    setCookieName(""); // Reset field when toggling
  };
  useEffect(() => {
    const fetchExperience = async () => {
      if (segmentId && experienceId && cookieId) {
        const response = await getCookiesData(
          experienceId,
          segmentId,
          cookieId
        );
        if (response.success === true && response.cookies) {
          const cookieData = response.cookies[0];
          setTitle(cookieData.title);
          setCookieName(cookieData.name);
          setCookieValue(cookieData.value);
          setDomain(cookieData.domain);
          setPath(cookieData.path);
          if (cookieData.sessionCookie) {
            setNoExpiration(true);
          } else {
            setNoExpiration(false);
            setExpirationValue(cookieData.expiration);
            setTimeUnit(cookieData.expirationUnit || "days");
          }
          setIsReadable(cookieData.name.startsWith("_pc_"));
        } else {
          console.log("Error fetching cookie data");
        }
      }
    };
    fetchExperience();
  }, [segmentId, experienceId, cookieId]);
  const validateForm = () => {
    let valid = true;
    let newErrors = { name: "", value: "", path: "", expirationValue: "" };

    if (!cookieName.trim()) {
      newErrors.name = "Cookie Name is required";
      valid = false;
    }

    if (!cookieValue.trim()) {
      newErrors.value = "Cookie Value is required";
      valid = false;
    }
    if (!path.trim()) {
      newErrors.path = "Cookie Path is required";
      valid = false;
    }
    if (!noExpiration && !expirationValue) {
      newErrors.expirationValue = "Expiration is required";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };
  const handleSave = async () => {
    if (!validateForm()) return;
    if (!title.trim()) {
      setTitleError(true);
      return;
    }
    const nodeType = sessionStorage.getItem("nodeType");
    let finalCookieName = cookieName;
    if (isReadable && !cookieName.startsWith("_pc_")) {
      finalCookieName = `_pc_${cookieName}`;
    }
    const payload: any = {
      name: isReadable ? finalCookieName : cookieName,
      value: cookieValue,
      domain: domain,
      path: path,
      sessionCookie: noExpiration,
      title: title,
    };
    if (nodeType === "paywall") {
      payload.meter_value_id = meterValueId;
    }
    if (!noExpiration) {
      payload.expiration = noExpiration ? null : expirationValue;
      payload.expirationUnit = noExpiration ? null : timeUnit.toLowerCase();
    }
    let response;
    try {
      setLoading(true);
      if (cookieId) {
        response = await EditsetCookie(
          experienceId,
          segmentId,
          cookieId,
          payload
        );
      } else {
        response = await createsetCookie(experienceId, segmentId, payload);
      }
      if (response.success === true) {
        toast.success(response.message);
        navigate(-1);
      } else {
        toast.error(response.error);
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };
  const onback = () => {
    navigate(`/edit-experience/${experienceId}`);
  };
  return (
    <div className="templates">
      <Grid container className="templates__header ">
        <Grid
          size={{ xs: 12, md: 3, sm: 6 }}
          className="templates__header--search"
        >
          <div className="d-center">
            <span className="Icon">
              <IconButton aria-label="close" onClick={onback}>
                <ArrowbackIcon />
              </IconButton>{" "}
            </span>{" "}
            <h2 className="mb-0"> Set Cookie</h2>
          </div>
        </Grid>
        <Grid
          size={{ xs: 12, md: 9, sm: 6 }}
          className="templates__header--button "
        >
          <Box className="button-heading">
            <Button
              sx={{
                "--variant-containedBg": "rgba(228, 0, 43, 1)",
                "&:hover": {
                  "--variant-containedBg": "rgba(228, 0, 43, 1)",
                  "--variant-textBg": "rgba(228, 0, 43, 0.04)",
                },
              }}
              variant="contained"
              className="button"
              color="error"
              onClick={handleSave}
              disabled={loading}
            >
              {loading ? <span className="loader" /> : "Save"}
            </Button>
            <Button
              sx={{
                "--variant-outlinedBorder": "rgba(228, 0, 43, 1)",
                "--variant-outlinedColor": "rgba(228, 0, 43, 1)",
                "--variant-containedBg": "rgba(228, 0, 43, 1)",

                "&:hover": {
                  "--variant-outlinedBorder": "rgba(228, 0, 43, 1)",
                  "--variant-outlinedBg": "rgba(228, 0, 43, 0.04)",
                  "--variant-containedBg": "rgba(228, 0, 43, 1)",
                  "--variant-textBg": "rgba(228, 0, 43, 0.04)",
                },
              }}
              className="button"
              variant="outlined"
              onClick={onback}
            >
              Cancel
            </Button>
          </Box>
        </Grid>
      </Grid>

      <Box className="editSegment__container" mt={2}>
        <Grid container alignItems={"center"}>
          <Grid size={{ xs: 12, md: 2, sm: 6 }}>
            <div className="editSegment__container--heading">
              <h2>TITILE OF CARD :</h2>
            </div>
          </Grid>
          <Grid
            size={{ xs: 12, md: 8, sm: 6 }}
            className="editSegment__container--heading"
          >
            <TextField
              variant="standard"
              value={title}
              fullWidth
              required
              error={titleError}
              helperText={titleError ? "Title is required" : ""}
              onChange={(e) => {
                const value = e.target.value;
                setTitle(value);
                if (value.trim()) {
                  setTitleError(false);
                }
              }}
            />
          </Grid>
        </Grid>
      </Box>

      <Box className="editSegment__container" p={2}>
        <h4>PROPERTIES</h4>
        <Grid container mt={2}>
          <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <Box className="editSegment__cookie" py={3} px={2}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <h4>COOKIE</h4>
                <div className="switch-wrapper">
                  <span>SET READABLE COOKIE &nbsp;</span>
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={isReadable}
                      onChange={handleToggle}
                    />
                    <span className="slider"></span>
                  </label>
                </div>
              </Box>
              <TextField
                fullWidth
                variant="standard"
                placeholder="The name of Cookie"
                value={
                  isReadable && cookieName.startsWith("_pc_")
                    ? cookieName.slice(4)
                    : cookieName
                }
                error={!!errors.name}
                helperText={errors.name}
                onChange={(e) => setCookieName(e.target.value)}
                InputProps={{
                  startAdornment: isReadable ? (
                    <InputAdornment position="start">_pc_</InputAdornment>
                  ) : null,
                }}
                sx={{
                  marginTop: "10px",
                }}
              />
            </Box>
          </Grid>

          <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <Box className="editSegment__cookie" py={3} px={2}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <h4>VALUE</h4>
              </Box>
              <TextField
                fullWidth
                variant="standard"
                placeholder="Value of the Cookie"
                value={cookieValue}
                error={!!errors.value}
                helperText={errors.value}
                onChange={(e) => setCookieValue(e.target.value)}
                sx={{
                  marginTop: "10px",
                }}
              />
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <Box className="editSegment__cookie" py={3} px={2}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <h4>PATH</h4>
              </Box>
              <TextField
                fullWidth
                variant="standard"
                placeholder="Path of the Cookie"
                value={path}
                error={!!errors.path}
                helperText={errors.path}
                onChange={(e) => setPath(e.target.value)}
                sx={{
                  marginTop: "10px",
                }}
              />
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <Box className="editSegment__cookie" py={3} px={2}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <h4>DOMAIN</h4>
              </Box>
              <TextField
                fullWidth
                variant="standard"
                placeholder="The Domain name"
                value={domain}
                onChange={(e) => setDomain(e.target.value)}
                sx={{
                  marginTop: "10px",
                }}
              />
            </Box>
          </Grid>
        </Grid>

        <Grid container>
          <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <Box className="editSegment__cookie" py={3} px={2}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <h4>EXPIRATION</h4>
                <div className="switch-wrapper">
                  <span>SESSION COOKIE &nbsp;</span>
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={noExpiration}
                      onChange={() => setNoExpiration(!noExpiration)}
                      color="success"
                    />
                    <span className="slider"></span>
                  </label>
                </div>
              </Box>
              <Box
                mt={2}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <TextField
                  fullWidth
                  variant="standard"
                  value={expirationValue}
                  error={!noExpiration && !!errors.expirationValue}
                  helperText={!noExpiration ? errors.expirationValue : ""}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    setExpirationValue(value);
                  }}
                  disabled={noExpiration}
                />

                <TextField
                  sx={{ minWidth: "fit-content" }}
                  select
                  value={timeUnit}
                  onChange={(e) => setTimeUnit(e.target.value)}
                  variant="standard"
                  disabled={noExpiration}
                >
                  <MenuItem value="days">Days</MenuItem>
                  <MenuItem value="hours">Hours</MenuItem>
                  <MenuItem value="minutes">Minutes</MenuItem>
                  <MenuItem value="seconds">Seconds</MenuItem>
                  <MenuItem value="months">Months</MenuItem>
                  <MenuItem value="years">Years</MenuItem>
                </TextField>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}

export default EditSetCookie;
